import type { MagazineTeaserArticleProps } from '@uikit/components/Magazine/MagazineTeaserArticle/interfaces';
import MagazineTeaserArticle from '@uikit/components/Magazine/MagazineTeaserArticle/MagazineTeaserArticle';

const MagazineHighlightTeaserWrapper = ({
  ...props
}: {
  article: MagazineTeaserArticleProps;
}) => {
  return <MagazineTeaserArticle {...props.article} variant="extraLarge" />;
};

export default MagazineHighlightTeaserWrapper;
